import { render, staticRenderFns } from "./SubidaDocumentos.vue?vue&type=template&id=27b97474&scoped=true"
import script from "./SubidaDocumentos.vue?vue&type=script&lang=js"
export * from "./SubidaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./SubidaDocumentos.vue?vue&type=style&index=0&id=27b97474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b97474",
  null
  
)

export default component.exports